import Stack from '@liquidweb-dev/undercurrent/Stack';
import Tooltip from '@liquidweb-dev/undercurrent/Tooltip';
import DetermineCountryFlag from 'containers/pages/shop/ConfigPackage/DetermineCountryFlag';
import { getLocationCode } from 'utility/locationCodes';
import Label from './Label';

const ServerDetailsLocation = ({
	location,
	country,
}: {
	location: string;
	country: string;
}) => {
	const locationCode = getLocationCode(location);
	return (
		<Tooltip
			title={locationCode ? location : undefined}
			placement="bottom"
			arrow
		>
			<Stack
				direction="row"
				alignItems="center"
				gap={50}
				minWidth={0}
				overflow="hidden"
			>
				<DetermineCountryFlag
					country={country || ''}
					sx={({ size }) => ({
						height: size.xS,
						width: size.xS,
						flexShrink: 0,
					})}
				/>
				<Label
					sx={{
						maxWidth: (theme) =>
							// icon + gap + minimum label width
							`calc((100% - ${theme.size.xS} - ${theme.spacing(50)} - ${theme.spacing(200)}) * 1000)`,
					}}
				>
					{locationCode || location}
				</Label>
			</Stack>
		</Tooltip>
	);
};

export default ServerDetailsLocation;
